<template>
  <div v-if="modelBlog?.show_as_object" class="overflow-auto">
    <pre class="text-white/80 bg-black rounded-xl p-4">{{ modelBlog }}</pre>
  </div>
  <BlogContentsEdit
    v-if="modelBlog?.is_editing"
    v-model="modelBlog"
    @moveup="methodMoveUp($event)"
    @movedown="methodMoveDown($event)"
    @addabove="methodAddContent($event, $event)"
    @addbelow="methodAddContent($event + 1, $event)"
    @remove="methodRemoveContent"
    />
  <BlogContentsShow
    v-else
    v-model="modelBlog"
    :keeplayout="keeplayout"
    @moveup="methodMoveUp($event)"
    @movedown="methodMoveDown($event)"
    @addabove="methodAddContent($event, $event)"
    @addbelow="methodAddContent($event + 1, $event)"
    @remove="methodRemoveContent"
    />
</template>

<script setup lang="ts">
defineProps<{
  keeplayout?: boolean
}>()
const modelBlog = defineModel<Blog>()

const methodMoveUp = (index: number) => {
  if(!modelBlog.value) return;
  modelBlog.value.elements?.splice(index-1, 0, modelBlog.value.elements.splice(index, 1)[0])
}

const methodMoveDown = (index: number) => {
  if(!modelBlog.value) return;
  modelBlog.value.elements?.splice(index+1, 0, modelBlog.value.elements.splice(index, 1)[0])
}

const methodAddContent = (index: number, initiator_id: number) => {
  if(!modelBlog.value) {
    modelBlog.value = {
      elements: [] as BlogElement[],
    } as Blog
  }

  if (!modelBlog.value.elements) {
    modelBlog.value.elements = []
  }

  // get element where this is clicked from
  const initiator = modelBlog.value.elements[initiator_id]

  modelBlog.value.elements.splice(index, 0, {
    id: Math.random().toString(36).substring(7) as string,
    type: 'paragraph' as BlogAvailableElements,
    content: 'I am a paragraph',
    inside: initiator?.inside || null,
    meta: {
      i18n: {
        en: {},
        de: {},
        es: {},
        uk: {},
        ru: {},
      }
    },
  } as BlogElement)
}

const methodRemoveContent = (index: number) => {
  if(!modelBlog.value || !index) return;
  modelBlog.value.elements?.splice(index, 1)
}
</script>
